module.exports = "<div data-ng-message=required>A name is required</div> ";